import { render, staticRenderFns } from "./AditivosForm.vue?vue&type=template&id=5e0758ac&scoped=true"
import script from "./AditivosForm.vue?vue&type=script&lang=js"
export * from "./AditivosForm.vue?vue&type=script&lang=js"
import style0 from "./AditivosForm.vue?vue&type=style&index=0&id=5e0758ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0758ac",
  null
  
)

export default component.exports